import { Grid } from '@material-ui/core';
import { useEffect, useState } from 'react';
import { FormControlLabel, Switch } from '@material-ui/core';
import {
    getGroupComparisonStock
} from '../../../Core/Service/Nicol_Common_services';

import StockReportFilters from '../UsedStockReport/usedStockReportFilters';
import { CSVLink } from "react-csv";
import GetApp from '@material-ui/icons/GetApp';
import CircularIndeterminate from '../../../Core/BudgetCore/loader';
import { GroupComparisonSummaryTable } from './groupComparisonComponents';
import './groupcomparison.scss';

const GroupStockComparison = () => {
    const [data, setData] = useState({
        tableComparisonLoader: true,
        benchMarkLoader: true,
        activeHeader: "Summary",
        sites: [],
        allSites: [],
        currentCoveredBranchIds: [],
        displayGroupBenchmark: false,
        displayGroupBenchmarkButton: false
    });

    const [isAppReady, setIsAppReady] = useState(false);

    const [selectedBranchList, setSelectedBranchList] = useState([]);

    const getSelectedBranchList = (list) => {
        setSelectedBranchList(list || []);
    };

    const getFilterData = async (value) => {
        var prevBranch = data.branchID || [];

        setData((st) => ({
            ...st,
            tableComparisonLoader: true,
            branchID: value.branchID,
            vehicleProfileIds: value.vehicleProfileIds,
            daysInStock: value.daysInStock,
            fuelType: value.fuelType,
            franNonFran: value.franNonFran,
            modelCodes: value.modelCodes
        }));

        const newBranchIds = value.branchID.filter(id => !data.currentCoveredBranchIds.includes(id));
        const removedBranch = prevBranch.filter(id => !value.branchID.includes(id));

        if (removedBranch.length > 0) {
            const hasSitesWithUnselectedBranches = data.allSites.filter(site =>
                site.branchesSelected.every(branchId => !value.branchID.includes(branchId))
            );

            if (hasSitesWithUnselectedBranches.length > 0) {
                var filteredBranches = data.allSites.filter(site =>
                    !site.branchesSelected.some(branchId => removedBranch.includes(branchId)));
                
                const coveredInQuery = filteredBranches.flatMap(cq => cq.branchesSelected);
                
                setData((st) => ({
                    ...st,
                    allSites: filteredBranches,
                    currentCoveredBranchIds: coveredInQuery
                }));
            }

            var sitesUpdate = data.sites.filter(branch => value.branchID.includes(branch.branchID));

            setData((st) => ({
                ...st,
                sites: sitesUpdate,
                tableComparisonLoader: false
            }));
        }
        
        if (newBranchIds.length > 0) {
            const dataSearch = {
                branchID: newBranchIds,
                vehicleProfileIds: value.vehicleProfileIds || [],
                daysInStock: value.daysInStock || [],
                fuelType: value.fuelType || [],
                franNonFran: value.franNonFran || [],
                modelCodes: value.modelCodes || [],
            };
          
            getBrandGroupData(dataSearch);
        }

        if (value.branchID.length > 1) {
            const dataSearchTemplate = {
                vehicleProfileIds: value.vehicleProfileIds || [],
                daysInStock: value.daysInStock || [],
                fuelType: value.fuelType || [],
                franNonFran: value.franNonFran || [],
                modelCodes: value.modelCodes || [],
            };
    
            // Run API calls for each branchID in parallel
            const results = await Promise.all(
                value.branchID.map(branchID => {
                    let dataSearch = {
                        ...dataSearchTemplate,
                        branchID: [branchID],
                    };
                    return getGroupComparisonStock(dataSearch);
                })
            );
    
            // Merge all returned sites together
            const combinedSites = results.flatMap(res => res.data.sites);
    
            // Update the state with combined sites
            setData((st) => ({
                ...st,
                sites: combinedSites,
                tableComparisonLoader: false
            }));
    
        } else if (value.branchID.length === 1) {
            // If only one branchID, make a single call
            const dataSearch = {
                branchID: value.branchID,
                vehicleProfileIds: value.vehicleProfileIds || [],
                daysInStock: value.daysInStock || [],
                fuelType: value.fuelType || [],
                franNonFran: value.franNonFran || [],
                modelCodes: value.modelCodes || [],
            };
    
            const res = await getGroupComparisonStock(dataSearch);
    
            setData((st) => ({
                ...st,
                sites: [...st.sites, ...res.data.sites],
                tableComparisonLoader: false
            }));
        }
    };

    const getBrandGroupData = async (value) => {
        setData((st) => ({
            ...st,
            benchMarkLoader: true
        }));

        const dataSearch = {
            branchID: value.branchID,
            vehicleProfileIds: value.vehicleProfileIds || [],
            daysInStock: value.daysInStock || [],
            fuelType: value.fuelType || [],
            franNonFran: value.franNonFran || [],
            modelCodes: value.modelCodes || [],
            brandGroupData: true
        };

        const res = await getGroupComparisonStock(dataSearch);

        const dedupeBySite = (sites) => 
            Array.from(new Map(sites.map(item => [item.site, item])).values()); 

        const coveredInQuery = res.data.allSitesData.flatMap(cq => cq.branchesSelected);

        setData((st) => ({
            ...st,
            allSites: dedupeBySite([...st.allSites, ...res.data.allSitesData]),
            currentCoveredBranchIds: Array.from(new Set([...st.currentCoveredBranchIds, ...coveredInQuery])),
            benchMarkLoader: false
        }));
    }

    const csvHeader = [
        {
            key: "site",
            label: "Site",
        },
        {
            key: "totalStock",
            label: "Total Stock"
        },
        {
            key: "stockTurn",
            label: "Stock Turn"
        },
        {
            key: "dis",
            label: "DIS"
        },
        {
            key: "overaged90",
            label: "Overaged(90+)"
        },
        {
            key: "advertisedStock",
            label: "Advertised Stock"
        },
        {
            key: "reserved",
            label: "Reserved"
        },
        {
            key: "totalActions",
            label: "Total Actions"
        },
        {
            key: "totalStockValue",
            label: "Total Stock Value"
        },
        {
            key: "avgSIV",
            label: "Avg.SIV"
        },
        {
            key: "totalWritedown",
            label: "Total Writedown"
        },
        {
            key: "retail",
            label: "Retail"
        },
        {
            key: "preReg",
            label: "Pre-Reg"
        },
        {
            key: "demo",
            label: "Demo"
        },
        {
            key: "cbs",
            label: "CBS"
        },
        {
            key: "cmv",
            label: "CMV"
        },
        {
            key: "courtesyCar",
            label: "Courtesy Car"
        },
        {
            key: "ltHire",
            label: "LT Hire"
        },
        {
            key: "trade",
            label: "Trade"
        },
        {
            key: "age030",
            label: "0-30"
        },
        {
            key: "age3060",
            label: "31-60"
        },
        {
            key: "age6190",
            label: "61-90"
        },
        {
            key: "dueIn7",
            label: "Due In (<7 Days)"
        },
        {
            key: "dueInEoM",
            label: "Due In (EoM)"
        },
        {
            key: "dueInLater",
            label: "Due In (Later)"
        },
        {
            key: "noPrice",
            label: "No Price"
        },
        {
            key: "noPhotos",
            label: "No Photos"
        },
        {
            key: "toPrep",
            label: "To Prep"
        },
        {
            key: "priceChange",
            label: "Price Change"
        },
        {
            key: "reserved3Plus",
            label: "Reserved 3+ Days"
        },
        {
            key: "stockBudget",
            label: "Stock Budget"
        },
        {
            key: "budgePerc",
            label: "% Budget"
        },
        {
            key: "retailPreReg",
            label: "Retail & Pre Reg Units"
        },
        {
            key: "atTrade",
            label: "AT Trade"
        },
        {
            key: "atVariance",
            label: "AT Variance"
        },
        {
            key: "capClean",
            label: "CAP Clean"
        },
        {
            key: "capVariance",
            label: "CAP Variance"
        },
    ];

    //Initial load
    useEffect(() => {
        let VehicleFilter = JSON.parse(localStorage.getItem('NicoleFilterData'))?.VehicleProfileIds || [];
        let initValues = {
            branchID: JSON.parse(localStorage.getItem('NicoleFilterData'))?.groupIds || [JSON.parse(localStorage.getItem('_defaultBranchID'))] || [],
            vehicleProfileIds: JSON.parse(localStorage.getItem('NicoleFilterData'))?.VehicleIdState ? VehicleFilter : ['R', 'A'] || [],
            VehicleIdState: JSON.parse(localStorage.getItem('NicoleFilterData'))?.VehicleProfileIds || false,
            daysInStock: JSON.parse(localStorage.getItem('NicoleFilterData'))?.daysInStockIds || [1],
            fuelType: JSON.parse(localStorage.getItem('NicoleFilterData'))?.fuelTypeIds || [1],
            franNonFran: JSON.parse(localStorage.getItem('NicoleFilterData'))?.franNonFranIds || [1],
            modelCodes: JSON.parse(localStorage.getItem('NicoleFilterData'))?.modelCodesIds || [0],
        }
        //getBrandGroupData(initValues);

        // Simulating async call
        getBrandGroupData(initValues).then(() => {
            setIsAppReady(true);
        });
    },[]);

    useEffect(() => {
        if (isAppReady) {
            handleGroupBenchmark();
        }
    }, [isAppReady]);


    const handleGroupBenchmark = async () => {
        const dataSearch = {
            branchID: data.branchID,
            vehicleProfileIds: data.vehicleProfileIds || [],
            daysInStock: data.daysInStock || [],
            fuelType: data.fuelType || [],
            franNonFran: data.franNonFran || [],
            modelCodes: data.modelCodes || [],
            groupBenchmark: true
        };

        const res = await getGroupComparisonStock(dataSearch);

        setData((st) => ({
            ...st,
            displayGroupBenchmarkButton: true,
            allSitesBenchmark: res.data.allSitesBenchmark
        }));
    }

    const handleDisplayGroupBenchmark = (e) => {
        const { checked } = e.target;

        setData((st) => ({
            ...st,
            displayGroupBenchmark: checked,
            benchMarkLoader: true
        }));

        if (checked) {
            setData((st) => ({
                ...st,
                allSites: [...st.allSitesBenchmark, ...st.allSites],
                benchMarkLoader: false
            }));
        } else {
            setData((st) => ({
                ...st,
                allSites: data.allSites.filter(site =>
                    site.site !== "GROUP"),
                benchMarkLoader: false
            }));
        }
    }

    return (
        <div className="boxSkel">
            <Grid container spacing={1} alignContent="center" justifyContent="space-between">
                <Grid item xs style={{ textAlign: 'left' }}>
                    <div className="titleBoxSkel">
                        Group Stock Comparison
                    </div>
                </Grid>
            </Grid>

            <StockReportFilters getFilterData={getFilterData} getSelectedBranchList={getSelectedBranchList} />

            <div className='exportCSVButtonWrp'>
                <div className='exportCSVButtonGroup'>
                    <CSVLink data={[...data.allSites, ...data.sites]} headers={csvHeader} target="_blank" filename={"GroupStockComparison.csv"}>
                        DOWNLOAD CSV
                        <GetApp />
                    </CSVLink>
                </div>
                <div className="toggleGroupButton">
                    {
                        data.displayGroupBenchmarkButton ? <>
                            <FormControlLabel
                                control={<Switch checked={data.displayGroupBenchmark} onChange={handleDisplayGroupBenchmark} name="displayGroupBenchmark" />}
                                label="Group Benchmark"
                                labelPlacement="start"
                            />
                        </> : <></>
                    }
                </div>
            </div>

            <div className='groupHeaders'>
                <div className={data.activeHeader === "Summary" ? "groupHeadersItem active" : "groupHeadersItem"}>
                    <span onClick={() => setData((st) => ({ ...st, activeHeader: "Summary" }))}>Summary</span>
                </div>
                <div className={data.activeHeader === "Profile" ? "groupHeadersItem active" : "groupHeadersItem"}>
                    <span onClick={() => setData((st) => ({ ...st, activeHeader: "Profile" }))}>Profile</span>
                </div>
                <div className={data.activeHeader === "Age" ? "groupHeadersItem active" : "groupHeadersItem"}>
                    <span onClick={() => setData((st) => ({ ...st, activeHeader: "Age" }))}>Age/Due-In</span>
                </div>
                <div className={data.activeHeader === "Actions" ? "groupHeadersItem active" : "groupHeadersItem"}>
                    <span onClick={() => setData((st) => ({ ...st, activeHeader: "Actions" }))}>Actions</span>
                </div>
                <div className={data.activeHeader === "Value" ? "groupHeadersItem active" : "groupHeadersItem"}>
                    <span onClick={() => setData((st) => ({ ...st, activeHeader: "Value" }))}>Value</span>
                </div>
            </div>
            <div className='groupTiles'>
                <div className={'groupTileWrp active'}>
                    <div className="groupTile top">
                        <span>BENCHMARK AVERAGES</span>
                        {
                            data.benchMarkLoader ? (
                                <CircularIndeterminate type="small" />
                            ) : (
                                <GroupComparisonSummaryTable type={data.activeHeader} sites={data.allSites} />
                            )
                        }
                    </div>
                    <div className="groupTile">
                        <span>SITE COMPARISONS</span>
                        {
                            data.tableComparisonLoader ? (
                                <CircularIndeterminate type="small" />
                            ) : (
                                <GroupComparisonSummaryTable type={data.activeHeader} sites={data.sites} />
                            )
                        }
                    </div>
                </div>
            </div>
        </div>
    );
};

export default GroupStockComparison;
